import { render, staticRenderFns } from "./AdminRouteTask.vue?vue&type=template&id=8afbb89e&scoped=true"
import script from "./AdminRouteTask.vue?vue&type=script&lang=js"
export * from "./AdminRouteTask.vue?vue&type=script&lang=js"
import style0 from "./AdminRouteTask.vue?vue&type=style&index=0&id=8afbb89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afbb89e",
  null
  
)

export default component.exports